(() => {
  if (window.pampasMobileQuickAddReady) return;
  window.pampasMobileQuickAddReady = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  let activeButton = null;
  let activeProduct = null;

  const money = (cents) =>
    new Intl.NumberFormat('he-IL', {
      style: 'currency',
      currency: 'ILS',
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);

  const mobileStyleProperties = [
    'appearance',
    '-webkit-appearance',
    'background',
    'background-color',
    'background-image',
    'border',
    'box-shadow'
  ];

  const syncMobilePresentation = (button) => {
    if (mobile.matches) {
      button.style.setProperty('appearance', 'none', 'important');
      button.style.setProperty('-webkit-appearance', 'none', 'important');
      button.style.setProperty('background', '#faf6f1', 'important');
      button.style.setProperty('background-color', '#faf6f1', 'important');
      button.style.setProperty('background-image', 'none', 'important');
      button.style.setProperty('border', '1px solid rgba(136, 92, 58, 0.55)', 'important');
      button.style.setProperty('box-shadow', '0 2px 7px rgba(61, 46, 32, 0.10)', 'important');
      return;
    }

    mobileStyleProperties.forEach((property) => button.style.removeProperty(property));
  };

  const decorateButton = (button) => {
    if (!button || button.dataset.pmQuickDecorated === 'true') return;
    if (button.dataset.personalizationRequired === 'true') {
      button.dataset.pmQuickDecorated = 'true';
      button.classList.add('pm-grid-cart--options');
      return;
    }
    const label = (button.textContent || '').replace(/\s+/g, ' ').trim();
    const hasOptions = /בחירת אפשרויות/.test(label);
    button.dataset.pmQuickDecorated = 'true';
    button.classList.add(hasOptions ? 'pm-grid-cart--options' : 'pm-grid-cart--add');
    button.textContent = '';

    const text = document.createElement('span');
    text.className = 'pm-grid-cart-label';
    text.textContent = label;
    button.append(text);

    const symbol = document.createElement('span');
    symbol.className = 'pm-grid-cart-symbol';
    symbol.setAttribute('aria-hidden', 'true');
    symbol.innerHTML = '<svg viewBox="0 0 24 24" focusable="false"><path d="M6.25 8.5h11.5l.85 11H5.4l.85-11Z" fill="none" stroke="#885c3a" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 9V6.7a3 3 0 0 1 6 0V9" fill="none" stroke="#885c3a" stroke-width="1.7" stroke-linecap="round"/><path d="M12 12.2v4.2M9.9 14.3h4.2" fill="none" stroke="#885c3a" stroke-width="1.7" stroke-linecap="round"/></svg>';
    button.append(symbol);
  };

  const decorateButtons = (root = document) => {
    root.querySelectorAll?.('.pampas-grid-cart-btn').forEach((button) => {
      decorateButton(button);
      syncMobilePresentation(button);
    });
  };

  const dialog = document.createElement('div');
  dialog.className = 'pm-mobile-quick-add';
  dialog.hidden = true;
  dialog.innerHTML = `
    <div class="pm-mobile-quick-add__backdrop" data-pm-quick-close></div>
    <div class="pm-mobile-quick-add__dialog" role="dialog" aria-modal="true" aria-labelledby="pmMobileQuickAddTitle" dir="rtl">
      <button class="pm-mobile-quick-add__close" type="button" data-pm-quick-close aria-label="סגירה">×</button>
      <h2 class="pm-mobile-quick-add__title" id="pmMobileQuickAddTitle"></h2>
      <label class="pm-mobile-quick-add__label" for="pmMobileQuickAddVariant">בחרו אפשרות</label>
      <select class="pm-mobile-quick-add__select" id="pmMobileQuickAddVariant"></select>
      <button class="pm-mobile-quick-add__submit" type="button">הוספה לעגלה</button>
      <p class="pm-mobile-quick-add__status" role="status" aria-live="polite"></p>
    </div>`;

  const title = dialog.querySelector('.pm-mobile-quick-add__title');
  const select = dialog.querySelector('.pm-mobile-quick-add__select');
  const submit = dialog.querySelector('.pm-mobile-quick-add__submit');
  const status = dialog.querySelector('.pm-mobile-quick-add__status');

  const closeDialog = () => {
    if (dialog.hidden) return;
    dialog.hidden = true;
    document.body.classList.remove('pm-mobile-quick-add-open');
    activeButton?.focus();
    activeButton = null;
    activeProduct = null;
  };

  const openDialog = (product, button) => {
    const variants = product.variants.filter((variant) => variant.available);
    activeProduct = product;
    activeButton = button;
    title.textContent = product.title;
    select.replaceChildren();

    variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = `${variant.title} — ${money(variant.price)}`;
      select.appendChild(option);
    });

    status.textContent = '';
    submit.disabled = variants.length === 0;
    dialog.hidden = false;
    document.body.classList.add('pm-mobile-quick-add-open');
    window.requestAnimationFrame(() => select.focus());
  };

  const announceAdded = (button) => {
    const label = button.querySelector?.('.pm-grid-cart-label');
    const original = label ? label.textContent : button.textContent;
    if (label) label.textContent = 'נוסף לעגלה ✓';
    else button.textContent = 'נוסף לעגלה ✓';
    window.setTimeout(() => {
      if (label) label.textContent = original;
      else button.textContent = original;
    }, 1600);
  };

  const addVariant = async (variantId, button) => {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'מוסיף לעגלה…';

    try {
      const response = await fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Cart request failed');

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: result.items?.[0] || result, addToCartBtn: button }
        })
      );
      document.dispatchEvent(new CustomEvent('cart:updated'));
      announceAdded(button);
      status.textContent = 'המוצר נוסף לעגלה';
      window.setTimeout(closeDialog, 450);
    } catch (error) {
      status.textContent = 'לא הצלחנו להוסיף לעגלה. נסו שוב.';
      console.error('[Pampas mobile quick add]', error);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  const loadProduct = async (grid) => {
    const handle = grid?.dataset.productHandle;
    if (!handle) throw new Error('Missing product handle');
    const root = window.theme?.routes?.home || '/';
    const url = `${root.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}.js`;
    const response = await fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
    return response.json();
  };

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('.pampas-grid-cart-btn');
      if (!button || !mobile.matches) return;
      if (button.dataset.personalizationRequired === 'true') return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      const buttonLabel = button.querySelector('.pm-grid-cart-label');
      const original = buttonLabel ? buttonLabel.textContent : button.textContent;
      if (buttonLabel) buttonLabel.textContent = 'טוען…';
      else button.textContent = 'טוען…';

      const restoreLabel = () => {
        if (buttonLabel) buttonLabel.textContent = original;
        else button.textContent = original;
      };

      try {
        const product = await loadProduct(button.closest('.grid-product'));
        const available = product.variants.filter((variant) => variant.available);
        if (available.length === 0) throw new Error('No available variants');

        if (product.variants.length === 1) {
          restoreLabel();
          button.removeAttribute('aria-busy');
          await addVariant(available[0].id, button);
        } else {
          restoreLabel();
          button.removeAttribute('aria-busy');
          openDialog(product, button);
        }
      } catch (error) {
        restoreLabel();
        button.removeAttribute('aria-busy');
        console.error('[Pampas mobile quick add]', error);
        window.location.href = button.closest('.grid-product')?.querySelector('.grid-product__image-link')?.href || '/collections/all';
      }
    },
    true
  );

  submit.addEventListener('click', () => {
    if (!activeProduct || !activeButton || !select.value) return;
    addVariant(select.value, submit);
  });
  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-pm-quick-close]')) closeDialog();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !dialog.hidden) closeDialog();
  });

  const mount = () => {
    if (!dialog.isConnected) document.body.appendChild(dialog);
    decorateButtons();
  };
  document.addEventListener('pampas:collection:products-loaded', (event) => {
    (event.detail?.products || []).forEach((product) => decorateButtons(product));
  });
  mobile.addEventListener?.('change', () => decorateButtons());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
})();
